import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../context/AppContext";

const Currency = (props) => {
  const { dispatch } = useContext(AppContext);
  const [SetNewCurrency, setCurrency] = useState("");

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
    changeCurrency();
  };

  const changeCurrency = () => {
    dispatch({
      type: "CHG_CURRENCY",
      payload: SetNewCurrency,
    });
  };

  useEffect(() => {
    const changeCurrency = () => {
      dispatch({
        type: "CHG_CURRENCY",
        payload: SetNewCurrency,
      });
    };
    changeCurrency();
  }, [SetNewCurrency, dispatch]);

  return (
    <>
      <p>Currency</p>
      <select
        className="alert alert-primary"
        id="inputGroupSelect02"
        onChange={handleCurrencyChange}
      >
        <option value="£" name="pound">
          £
        </option>
        <option value="$" name="dollar">
          $
        </option>

        <option value="€" name="euro">
          €
        </option>
        <option value=" ₹" name="ruppee">
          ₹
        </option>
      </select>
    </>
  );
};
export default Currency;
